class MenuAccordion {
  constructor() {
    this.drawer = document.getElementById('m-menu-drawer');
    if (!this.drawer) {
      console.warn('MenuAccordion: Drawer element not found');
      return;
    }
    
    this.activeAccordions = new Set();
    this.resizeObserver = null;
    this.init();
  }

  /*Inicialización del accordion*/
  init() {
    this.drawer.addEventListener('click', this.handleClick.bind(this));
    this.setupResizeObserver();
  }


  handleClick(e) {
    const toggleButton = e.target.closest('[data-accordion-toggle]');
    if (toggleButton) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleAccordion(toggleButton);
      return;
    }

    const parentLink = e.target.closest('.m-menu-mobile__item--has-children > .m-menu-mobile__header .m-menu-mobile__link');
    if (parentLink) {
      e.preventDefault();
      e.stopPropagation();
      
      const header = parentLink.closest('.m-menu-mobile__header');
      const toggleBtn = header.querySelector('[data-accordion-toggle]');
      if (toggleBtn) {
        this.toggleAccordion(toggleBtn);
      }
      return;
    }

    const header = e.target.closest('.m-menu-mobile__item--has-children > .m-menu-mobile__header');
    if (header) {
      e.preventDefault();
      e.stopPropagation();
      const toggleBtn = header.querySelector('[data-accordion-toggle]');
      if (toggleBtn) {
        this.toggleAccordion(toggleBtn);
      }
    }
  }

  /*Toggle del estado del acordeón*/
  toggleAccordion(button) {
    const menuItem = button.closest('.m-menu-mobile__item');
    const accordionContent = menuItem.querySelector(':scope > .m-menu-mobile__accordion-content');
    
    if (!accordionContent) {
      console.warn('MenuAccordion: Content container not found');
      return;
    }

    const isOpen = menuItem.classList.contains('is-open');

    if (isOpen) {
      this.closeAccordion(menuItem, button, accordionContent);
    } else {
      this.closeSiblingAccordions(menuItem);
      this.openAccordion(menuItem, button, accordionContent);
    }
  }

  /*Abrir acordeón con cálculo dinámico de altura*/
  openAccordion(menuItem, button, accordionContent) {
    menuItem.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    this.activeAccordions.add(menuItem);
    
    requestAnimationFrame(() => {
      this.updateAccordionHeight(accordionContent);
      // Recalcular altura de todos los padres
      this.updateParentHeights(menuItem);
    });

    setTimeout(() => this.scrollIfNeeded(menuItem), 350);
  }

  /*Cerrar acordeón*/
  closeAccordion(menuItem, button, accordionContent) {
    menuItem.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
    accordionContent.style.maxHeight = '0';
    this.activeAccordions.delete(menuItem);
    
    this.closeChildAccordions(accordionContent);
    
    // Recalcular padres después de cerrar
    setTimeout(() => {
      this.updateParentHeights(menuItem);
    }, 50);
  }

  /*Actualizar altura del acordeón (útil cuando hay imágenes)*/
  updateAccordionHeight(accordionContent) {
    const contentHeight = accordionContent.scrollHeight;
    accordionContent.style.maxHeight = contentHeight + 'px';
    
    const images = accordionContent.querySelectorAll('img');
    if (images.length > 0) {
      images.forEach(img => {
        if (!img.complete) {
          img.addEventListener('load', () => {
            if (accordionContent.parentElement.classList.contains('is-open')) {
              requestAnimationFrame(() => {
                accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
                // Actualizar padres cuando cargue la imagen
                const menuItem = accordionContent.parentElement;
                this.updateParentHeights(menuItem);
              });
            }
          }, { once: true });
        }
      });
    }
  }

  /*Actualizar altura de acordeones padres cuando se abre/cierra un hijo*/
  updateParentHeights(menuItem) {
    let currentItem = menuItem;
    
    // Buscar todos los padres que sean acordeones abiertos
    while (currentItem) {
      const parentAccordion = currentItem.parentElement.closest('.m-menu-mobile__item--has-children.is-open');
      
      if (parentAccordion) {
        const parentContent = parentAccordion.querySelector(':scope > .m-menu-mobile__accordion-content');
        if (parentContent) {
          requestAnimationFrame(() => {
            const newHeight = parentContent.scrollHeight;
            parentContent.style.maxHeight = newHeight + 'px';
          });
        }
        currentItem = parentAccordion;
      } else {
        break;
      }
    }
  }

  /*Cerrar acordeones hijos recursivamente*/
  closeChildAccordions(container) {
    const childItems = container.querySelectorAll('.m-menu-mobile__item--has-children.is-open');
    childItems.forEach(child => {
      const button = child.querySelector('[data-accordion-toggle]');
      const content = child.querySelector('.m-menu-mobile__accordion-content');
      if (button && content) {
        this.closeAccordion(child, button, content);
      }
    });
  }

  /*Cerrar acordeones hermanos del mismo nivel*/
  closeSiblingAccordions(currentItem) {
    const parent = currentItem.parentElement;
    
    const siblings = Array.from(parent.children).filter(child =>
      child !== currentItem &&
      child.classList.contains('m-menu-mobile__item--has-children') &&
      child.classList.contains('is-open')
    );
    
    siblings.forEach(sibling => {
      const button = sibling.querySelector(':scope > .m-menu-mobile__header [data-accordion-toggle]');
      const content = sibling.querySelector(':scope > .m-menu-mobile__accordion-content');
      if (button && content) {
        this.closeAccordion(sibling, button, content);
      }
    });
  }

  /*Scroll suave si el elemento está fuera de la vista*/
  scrollIfNeeded(element) {
    const rect = element.getBoundingClientRect();
    const drawerRect = this.drawer.getBoundingClientRect();
    
    if (rect.bottom > drawerRect.bottom || rect.top < drawerRect.top) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }

  /*Observer para detectar cambios de tamaño en el contenido*/
  setupResizeObserver() {
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
          const menuItem = entry.target.closest('.m-menu-mobile__item--has-children');
          if (menuItem && menuItem.classList.contains('is-open')) {
            const content = menuItem.querySelector('.m-menu-mobile__accordion-content');
            if (content) {
              requestAnimationFrame(() => {
                this.updateAccordionHeight(content);
                this.updateParentHeights(menuItem);
              });
            }
          }
        });
      });

      const accordionContents = this.drawer.querySelectorAll('.m-menu-mobile__accordion-content');
      accordionContents.forEach(content => {
        this.resizeObserver.observe(content);
      });
    }
  }

  /*Cerrar todos los acordeones (útil al cerrar el drawer)*/
  closeAllAccordions() {
    this.activeAccordions.forEach(item => {
      const button = item.querySelector('[data-accordion-toggle]');
      const content = item.querySelector('.m-menu-mobile__accordion-content');
      if (button && content) {
        this.closeAccordion(item, button, content);
      }
    });
    this.activeAccordions.clear();
  }

  /*Destructor para cleanup*/
  destroy() {
    this.drawer.removeEventListener('click', this.handleClick);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    this.activeAccordions.clear();
  }
}

const initMenuAccordion = () => {
  if (window.menuAccordion && typeof window.menuAccordion.destroy === 'function') {
    window.menuAccordion.destroy();
  }
  
  window.menuAccordion = new MenuAccordion();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMenuAccordion);
} else {
  initMenuAccordion();
}

document.addEventListener('click', (e) => {
  const backdrop = e.target.closest('.m-menu-drawer__backdrop');
  if (backdrop && window.menuAccordion) {
    window.menuAccordion.closeAllAccordions();
  }
});

let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    if (window.menuAccordion && window.menuAccordion.activeAccordions.size > 0) {
      window.menuAccordion.activeAccordions.forEach(item => {
        const content = item.querySelector('.m-menu-mobile__accordion-content');
        if (content) {
          requestAnimationFrame(() => {
            window.menuAccordion.updateAccordionHeight(content);
            window.menuAccordion.updateParentHeights(item);
          });
        }
      });
    }
  }, 250);
});
